import classNames from 'classnames';
import { FunctionComponent } from 'react';
import { MoonIconProps } from './MoonIconProps';

export const MoonIcon: FunctionComponent<MoonIconProps> = ({ className, style, color = '#E60012' }) => {
  return (
    <svg
      className={classNames('h-full w-full', className)}
      style={style}
      viewBox="0 0 52 51"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Moon</title>
      <g id="Moon" stroke="none" strokeWidth="1" fillRule="evenodd">
        <path
          className="transition-color-widget"
          d="M20.5,0 C22.5372719,0 24.2583419,1.35382103 24.8126375,3.21089043 C25.8541956,3.07150207 26.9187477,3 28,3 C41.254834,3 52,13.745166 52,27 C52,40.254834 41.254834,51 28,51 C18.2064295,51 9.78295126,45.133938 6.05149264,36.7237415 C5.56837209,36.9029294 5.04552208,37 4.5,37 C2.01471863,37 0,34.9852814 0,32.5 C0,30.0147186 2.01471863,28 4.5,28 C6.98528137,28 9,30.0147186 9,32.5 C9,32.9112699 8.9448282,33.3096538 8.84148214,33.688154 C9.86241216,33.8927333 10.9186793,34 12,34 C20.836556,34 28,26.836556 28,18 C28,13.9214398 26.4739472,10.1993084 23.961688,7.37345194 C23.1371237,8.36758635 21.8924159,9 20.5,9 C18.0147186,9 16,6.98528137 16,4.5 C16,2.01471863 18.0147186,0 20.5,0 Z M34,21 C32.8954305,21 32,22 32,27.5 C32,33 32.8954305,34 34,34 C35.1045695,34 36,33 36,27.5 C36,22 35.1045695,21 34,21 Z M43,21 C41.8954305,21 41,22 41,27.5 C41,33 41.8954305,34 43,34 C44.1045695,34 45,33 45,27.5 C45,22 44.1045695,21 43,21 Z"
          id="Combined-Shape"
          fill={color}
        ></path>
      </g>
    </svg>
  );
};
